//
//
//
//
//
//

export default {
  name: 'mt-fixed-container',
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    },
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    top: String,
    left: String,
    bottom: String,
    right: String
  },
  computed: {
    computeStyle:function(){
      let _style = '';
      let top = this.top;
      let left = this.left;
      let bottom = this.bottom;
      let right = this.right;
      if (top) {
          _style += `top: ${top};`;
      }

      if (left) {
          _style += `left: ${left};`;
      }
      if (bottom) {
          _style += `bottom: ${bottom};`;
      }

      if (right) {
          _style += `right: ${right};`;
      }
      return _style;
    }
  }

};



// WEBPACK FOOTER //
// ./packages/fixed-container/src/fixed-container.vue